import React, { useEffect, useState } from "react";
import { Input, Table } from "reactstrap";
import CustomInput from "../../../../Components/Common/CustomInput/CustomInput";

const addZeroPrefix = (number) => {
  let numString = number.toString();

  if (numString.length === 1) {
    numString = "0" + numString;
  }

  return Number(numString);
};

const DetailTable = ({
  mainHeading,
  headings,
  subHeadings,
  index,
  read,
  formik,
  report,
  onWheel,
  disableDraft,
  isVisible,
  toggleVisibility,
}) => {
  const [debitTotal, setDebitTotal] = useState([]);
  const [creditTotal, setCreditTotal] = useState([]);

  useEffect(() => {
    if (headings) {
      const initialDebitTotal = headings.map((item, i) => {
        return item.subHeadings.reduce((acc, subitem, subindex) => {
          const debit =
            formik.values.reportTxns?.[index]?.reportSubTxnDtos?.[i]?.subTxnDtos?.[subindex]?.debit || 0;
          return acc + Number(debit);
        }, 0);
      });

      const initialCreditTotal = headings.map((item, i) => {
        return item.subHeadings.reduce((acc, subitem, subindex) => {
          const credit =
            formik.values.reportTxns?.[index]?.reportSubTxnDtos?.[i]?.subTxnDtos?.[subindex]?.credit || 0;
          return acc + Number(credit);
        }, 0);
      });

      setDebitTotal(initialDebitTotal);
      setCreditTotal(initialCreditTotal);
    }
  }, [headings, formik.values.reportTxns, index]);

  const handleWheel = (e) => {
    if (e.target.type === "number") {
      e.preventDefault();
    }
  };

  return (
    <>
      <div className="table-responsive table-card w-full">
        <Table
          size="sm"
          striped
          responsive
          className="table align-middle table-nowrap"
        >
          <thead className="table-light">
            <tr style={{ backgroundColor: "#e5edf6" }}>
              <td>
                {isVisible
                  ? mainHeading?.mainHeadingEngName
                  : mainHeading?.mainHeadingNepName}
              </td>
            </tr>
          </thead>
        </Table>
      </div>
      {headings?.map((item, i) => {
        return (
          <div key={i} className="table-responsive table-card  w-full">
            <Table size="sm" className="table align-middle table-nowrap">
              <thead className="table-light">
                <tr className="text-muted">
                  <td>S.N</td>
                  <td>DESCRIPTION</td>
                  <td className="text-center">CREDIT</td>
                  <td className="text-center">DEBIT</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="table-light fw-bold" colSpan="12">
                    {item?.headingEngName ?? ""}
                  </td>
                </tr>
                {item?.subHeadings?.map((subitem, subindex) => {
                  return (
                    <tr key={subindex}>
                      <td>
                        <span
                          className="form-control border-0"
                          style={{ backgroundColor: "#f8f9fa" }}
                        >
                          {subindex + 1}
                        </span>
                      </td>
                      <td className="col-sm-5">
                        <span
                          className="form-control border-0 fw-bold"
                          style={{ backgroundColor: "#f8f9fa" }}
                        >
                          {isVisible
                            ? subitem.subheadingNepName
                            : subitem.subheadingEngName}
                        </span>
                      </td>

                      <td>
                        <h6 className="text-end">
                          {formik.values.reportTxns?.[index]?.reportSubTxnDtos?.[i]?.subTxnDtos?.[subindex]?.credit || ""}
                        </h6>
                      </td>

                      <td>
                        <h6 className="text-end">
                          {formik.values.reportTxns?.[index]?.reportSubTxnDtos?.[i]?.subTxnDtos?.[subindex]?.debit || ""}
                        </h6>
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td>
                    <span></span>
                  </td>
                  <td className="col-sm-5">
                    <span
                      className="form-control border-0 fw-bold"
                      style={{ backgroundColor: "#f8f9fa" }}
                    >
                      Total (Rs.)
                    </span>
                  </td>
                  <td>
                    <h6 className="text-end">{creditTotal[i] || 0}</h6>
                  </td>
                  <td>
                    <h6 className="text-end">{debitTotal[i] || 0}</h6>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        );
      })}
    </>
  );
};

export default DetailTable;
